import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
    selector: 'ridango-ui-basic-loading-spinner',
    templateUrl: './basic-loading-spinner.component.html',
    styleUrls: ['./basic-loading-spinner.component.scss']
})
export class BasicLoadingSpinnerComponent implements OnInit {
    @Input() ariaLabel: string;

    constructor(
        private liveAnnouncer: LiveAnnouncer,
        private translate: TranslateService
    ) {}

    ngOnInit() {
        const message = this.translate.instant(this.ariaLabel ? this.ariaLabel : 'CONTENT_LOADING_PLEASE_WAIT');
        this.liveAnnouncer.announce(message);
    }
}
